/**
 * 處理報名成功的幫助工具
 * 主要用於解決報名成功後直接跳轉頁面導致用戶沒看到成功信息的問題
 */

/**
 * 保存報名成功狀態到localStorage
 * @param data 報名成功的相關數據
 */
export const saveApplySuccess = (data: any) => {
  try {
    localStorage.setItem('micepass_apply_success', JSON.stringify({
      timestamp: Date.now(),
      data
    }));
  } catch (e) {
    console.error('無法保存報名成功狀態', e);
  }
};

/**
 * 檢查報名成功狀態，若存在且未過期則返回
 */
export const getApplySuccess = () => {
  try {
    const savedData = localStorage.getItem('micepass_apply_success');
    if (!savedData) return null;
    
    const parsedData = JSON.parse(savedData);
    const now = Date.now();
    const dataTimestamp = parsedData.timestamp || 0;
    
    // 只保留30分鐘內的報名記錄
    if (now - dataTimestamp > 30 * 60 * 1000) {
      localStorage.removeItem('micepass_apply_success');
      return null;
    }
    
    return parsedData.data;
  } catch (e) {
    console.error('讀取報名狀態失敗', e);
    return null;
  }
};

/**
 * 清除報名成功狀態
 */
export const clearApplySuccess = () => {
  try {
    localStorage.removeItem('micepass_apply_success');
  } catch (e) {
    console.error('清除報名狀態失敗', e);
  }
};

export default {
  saveApplySuccess,
  getApplySuccess,
  clearApplySuccess,
}; 